import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const PhilosophyPage = lazy(() => import('../pages/philosophy/page'));
const SafetyPage = lazy(() => import('../pages/safety/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/philosophy',
    element: <PhilosophyPage />,
  },
  {
    path: '/safety',
    element: <SafetyPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;